import Template from '../../component/Template.js';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import Select from 'react-select'; //04-03-2024-multiselect

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Api from '../../component/Api.js';
import { Link } from 'react-router-dom';
import React, { useRef } from "react";

import 'datatables.net';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import $ from 'jquery';
import SchoolIcon from '@mui/icons-material/School';

export default function SFAUserMappingDetails() {

  const [getCollegeTeacherData, setCollegeTeacherData] = useState([]);
  const tableRef = useRef(null);
  const [getCourseData, setCourseData] = useState([]);
  const [courseDiciplineNameData, setCourseDiciplineNameData] = useState([]);
  const [courseDiciplineIDData, setCourseDiciplineIDData] = useState([]);
  const [courseDiciplineSchemeID, setCourseDiciplineSchemeID] = useState([]);


  const [getCourseMappingStatusSummaryData, setCourseMappingStatusSummaryData] = useState([]);

  const [isFirstSubmit, setFirstSubmit] = useState(false);
  const [mappedCourses, setMappedCourses] = useState([]);
  const [reload, setReload] = useState(false);
  const [unmappedCount, setUnmappedCount] = useState(0);
  const [activeSemesterId, setActiveSemesterId] = useState(null);
  const [getEventMsg, setEventMsg] = useState(false);
  const [getActiveEvents, setActiveEvents] = useState(false);
  const [getAllCourseStatusData, setAllCourseStatusData] = useState(false);


  /* CUSTOM DATA TABLE END HERE */

  const { http } = Api();
  const navigate = useNavigate();

  let { yearid, semid, discid, disctype, singlefaculty } = useParams();

  const decodedYear = atob(yearid);
  const decodedSemID = atob(semid);
  const decodedDiscID = atob(discid);
  const decodedDiscType = atob(disctype);
  const decodedSinglefaculty = atob(singlefaculty);

  const isAuth = useAuth();
  if (isAuth === false) {
    navigate("/college/");
  }

  let cid = localStorage.getItem("collegeid");
  let collegename = localStorage.getItem("username");

  useEffect(() => {   
    
    const fetchActiveEvents = async () => {

      try {
        const response = await http.get('getActiveEvents', {
          params: { event_id: 21 }
        });

        const events = Array.isArray(response.data) ? response.data : [response.data];
        const matchedEvent = events.find(event =>
          Number(event.admission_year) === Number(decodedYear) &&
          Number(event.semester_id) === Number(decodedSemID)
        );

        if (matchedEvent) {
          setActiveEvents(matchedEvent);

        } else {
          setActiveEvents([]);

          setEventMsg(false);
        }
      } catch (error) {
        console.log("API Error:", error);
        setActiveSemesterId(null);
        setActiveEvents([]);


        setEventMsg(false);

        const status1 = error.response?.data?.http_status;
        const message = error.response?.data?.message || "An error occurred";
        const status = error.response?.status;
        const errorCode = error.response?.data?.status_code;

        if (message.includes('Attempt to read property "user_id"')) {
          toast.error("Session expired. Please log in again.");
          setTimeout(() => navigate("/sfa/"), 3000);
        }
        else if ((status === 500 && message.includes('user_id')) || message.includes('Attempt to read property "user_id"')) {
          toast.error("Session expired. Please log in again.");
          setTimeout(() => navigate("/sfa/"), 3000);
        } else if (status === 403 && errorCode === "ERR37") {
          toast.error("Invalid Token");
          setTimeout(() => navigate("/sfa/"), 3000);
        } else {
          toast.error(message);
        }
      }

    };

    fetchActiveEvents();
  }, []);


  useEffect(() => {

    http.get('/College/getCollegerTeacher', {
      params: {
        college_id: cid,
        admissionyear: decodedYear,
        semester_id: decodedSemID,
        discipline_id: decodedDiscID,
        course_type: decodedDiscType

      },
    })
      .then((response) => {
        setCollegeTeacherData(response.data);
      })
      .catch((error) => {
        const status = error.response?.data?.http_status;
        const message = error.response?.data?.message || "An error occurred";

        if (status === 500 || error.response?.data?.status_code === "ERR5") {

          toast.error("No seat names were found");
        } else if (status === 403 && error.response?.data?.status_code === "ERR37") {
          toast.error("Invalid Token");
          setTimeout(() => navigate("/college/"), 5000);
        } else {
          toast.error("Something went wrong");
        }
      });


  }, [reload]);

  useEffect(() => {
    const getSFASideCollegeCourseForTeacher = async () => {
      http.get('/College/getSFASideCollegeCourseForTeacher', {
        params: {
          college_id: cid,
          admissionyear: decodedYear,
          semester_id: decodedSemID,
          discipline_id: decodedDiscID,
          college_course_type: decodedDiscType
        },
      })
        .then((response) => {
          setCourseData(response.data.course);
          setCourseDiciplineNameData(response.data.discipline_name);
          setCourseDiciplineIDData(response.data.selected_discipline_id);
          setCourseDiciplineSchemeID(response.data.scheme_id);

          const courses = response.data.course || [];
           // Check if all course_status are approved
          const allApproved = courses.every(course => course.course_status === 'approved');

          if (allApproved) {
            setAllCourseStatusData('allApproved'); // or true
          } else {
            setAllCourseStatusData('notAllApproved'); // or false
          }

          // Set mapped courses (all courses from API)
          const tempMappedCourses = courses.map(course => ({
            course_id: course.course_id,
            college_course_type: course.college_course_type,
            avail_course: course.avail_course
          }));

          setMappedCourses(tempMappedCourses);


        }).catch((error) => {
          setAllCourseStatusData(false);

          const status = error.response?.data?.http_status;
          const message = error.response?.data?.message || "An error occurred";

          if (status === 500 || error.response?.data?.status_code === "ERR5") {
            toast.error(message);
          } else if (status === 403 && error.response?.data?.status_code === "ERR37") {
            toast.error("Invalid Token");
            setTimeout(() => navigate("/college/"), 5000);
          } else {
            toast.error("Something went wrong");
          }
        });
    };

    if (decodedYear && decodedSemID && decodedDiscID) {
      getSFASideCollegeCourseForTeacher();
    }


  }, [reload]);

  useEffect(() => {
    const getCourseMappingStatusSummary = async () => {
      http.get('/College/getCourseMappingStatusSummary', {
        params: {
          college_id: cid,
          admissionyear: decodedYear,
          semester_id: decodedSemID,
          discipline_id: decodedDiscID,
          college_course_type: decodedDiscType

        },
      }).then((response) => {
        setCourseMappingStatusSummaryData(response.data);
      }).catch((error) => {
        const status = error.response?.data?.http_status;
        const message = error.response?.data?.message || "An error occurred";

        if (status === 500 || error.response?.data?.status_code === "ERR5") {
          toast.error(message);
        } else if (status === 403 && error.response?.data?.status_code === "ERR37") {
          toast.error("Invalid Token");
          setTimeout(() => navigate("/college/"), 5000);
        } else {
          //toast.error(message);
          toast.error("Something went wrong");
        }
      });
    };

    if (decodedYear && decodedSemID && decodedDiscID) {

      getCourseMappingStatusSummary();
    }


  }, [reload]);

  const handleGeneratePDFNew = async (discipline_id, disciplineName) => {
    // setLoading(true);
    try {
      const response = await http.get('/College/pdf_download', {
        params: {
          college_id: cid,
          admissionyear: decodedYear,
          semester_id: decodedSemID,
          discipline_id: discipline_id,
          course_type: decodedDiscType

        },
        responseType: 'blob', // Expect binary response
      });

      if (response && response.data) {
        // Create a URL for the downloaded file
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;

        // Set the file name and download the PDF
        link.setAttribute(
          'download',
          `${localStorage.getItem('username')}_${disciplineName}_TeacherCourseMapping.pdf`
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // setLoading(false);
        toast.success('PDF generated successfully');
      }
    } catch (error) {
      //console.log("error",error);
      // setLoading(false);
      if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
        toast.error("Invalid Token");
        setTimeout(() => {
          navigate("/college/");
        }, 5000);

      }
      else if (error.response.data.http_status === 500 && error.response.data.status_code == "ERR47") {
        toast.error(error.response.data.message);
      }
      else {
        console.error('Error generating PDF:', error);
        toast.error('Error generating PDF');
      }
    }
  };

  //Old code of mapped course approved only
  // useEffect(() => {
  //   if (getCourseData.length > 0 && getCollegeTeacherData.length > 0) {
  //     const tempMappedCourses = [];

  //     getCourseData.forEach((course) => {
  //       const relatedTeachers = getCollegeTeacherData.filter(teacher =>
  //         teacher.courses?.includes(course.course_id)
  //       );

  //       if (relatedTeachers.length > 0) {
  //         tempMappedCourses.push({
  //           course_id: course.course_id,
  //           college_course_type: course.college_course_type,
  //           avail_course: course.avail_course
  //         });
  //       }
  //     });

  //     setMappedCourses(tempMappedCourses);
  //   }
  // }, [getCourseData, getCollegeTeacherData]);

  // const handlefirstsubmit = () => {

  //   setFirstSubmit(!isFirstSubmit);

  // }

  const handlefirstsubmit = () => {

      if (getAllCourseStatusData === 'allApproved') {
          toast.info("The mapping of courses and teachers has already been approved.");
          return; // Do nothing further
        }


    // Check if ALL courses are unmapped (course_status null or empty)
    const checkAllUnmapped = getCourseData.every(course =>
      !course.course_status || course.course_status.trim() === ""
    );

    if (checkAllUnmapped) {
      toast.error("No courses have been mapped. Please map at least one course before approving.");
      return; // Prevent further execution
    }

    const unmappedCourses = getCourseData.filter(course =>
      !getCollegeTeacherData.some(teacher => teacher.courses.includes(course.course_id))
    );

    
    if (unmappedCourses.length > 0) {
      setUnmappedCount(unmappedCourses.length); // state to hold count
      setFirstSubmit(true); // show modal
    } else {
      setUnmappedCount(0);
      setFirstSubmit(true); // still show modal for confirmation
    }
  };

  const handleFinalSubmit = () => {
    const payload = {
      college_id: cid,
      admissionyear: decodedYear,
      semester_id: decodedSemID,
      discipline_id: decodedDiscID,
      course_type: decodedDiscType,
      mapped_courses: mappedCourses // ✅ include your collected mappings
    };

    http.post('/College/saveCourseTeacherMappingData', payload)
      .then(response => {
        if (response.data.status_code === "MSG2" && response.status === 200) {
          setFirstSubmit(!isFirstSubmit);

          setReload(!reload);

          toast.success("Course Approved successfully!");
        }
      })
      .catch(error => {
        setReload(false);
        const status = error.response?.data?.http_status;
        const message = error.response?.data?.message || "An error occurred";

        if (status === 500 || error.response?.data?.status_code === "ERR5") {
          toast.error(message);
        } else if (status === 403 && error.response?.data?.status_code === "ERR37") {
          toast.error("Invalid Token");
          setTimeout(() => navigate("/college/"), 5000);
        } else {
          //toast.error(message);
          toast.error("Something went wrong");
        }
        toast.error("Failed to save mapping");
      });
  };

  const handleCancel = () => {
    setFirstSubmit(!isFirstSubmit);
    //window.location.reload();
  }

  const cancelForm = () => {
    window.location.reload();
  };

  return (
    <>
      <ToastContainer />
      <Template>
        <div className="container-fluid">
          <div className="row">
            <div className="table-responsive">
              <div className="card">
                <div className="col-md-12">
                  <div className="card-header">
                    <div className="py-3 d-flex justify-content-between align-items-center">
                      <h5>{courseDiciplineNameData && courseDiciplineNameData.length > 0 ? (
                        `${courseDiciplineNameData}${courseDiciplineSchemeID === 4 ? '(B.Voc)' : ''} : Teacher Mapping Details`
                      ) : (
                        "Teacher Mapping Details"
                      )} {decodedSinglefaculty === "0" ? ' - Single Faculty Course' : ''}
                      </h5>


                    </div>
                  </div>
                  <div className="card-body">
                    <div className="table-responsive">
                      <div className="card-body">

                        <div className="container">
                          <div className="table-responsive ovrflw" style={{ overflowX: 'auto' }}>
                            <div className="row justify-content-center">
                              <div className="col-md-10 stat-out-bod">

                                <table className="table-striped  table-bordered ex-table mb-10" ref={tableRef} id="dataTable" width="100%" style={{ textAlign: 'center', tableLayout: 'fixed' }}>
                                  <tbody>
                                    <tr className="col-cnt-tab-bg-clr" style={{ height: '40px' }}>

                                      <th colSpan="2" style={{ textAlign: "center", verticalAlign: "middle", width: '50%', }}>Total Courses</th>
                                      <td colSpan="2" style={{ textAlign: "center", verticalAlign: "middle", width: '50%', }}>{getCourseMappingStatusSummaryData.total_courses ? getCourseMappingStatusSummaryData.total_courses : '0'}</td>
                                    </tr>
                                    <tr className="col-cnt-tab-bg-clr" style={{ height: '40px' }}>

                                      <th colSpan="2" style={{ textAlign: "center", verticalAlign: "middle", width: '50%', }}>Mapped Courses</th>
                                      <td colSpan="2" style={{ textAlign: "center", verticalAlign: "middle", width: '50%', }}>{getCourseMappingStatusSummaryData.mapped_courses ? getCourseMappingStatusSummaryData.mapped_courses : '0'}</td>
                                    </tr>
                                    <tr className="col-cnt-tab-bg-clr" style={{ height: '40px' }}>

                                      <th colSpan="2" style={{ textAlign: "center", verticalAlign: "middle", width: '50%', }}>Mapping Pending Courses</th>
                                      <td colSpan="2" style={{ textAlign: "center", verticalAlign: "middle", width: '50%', }}>{getCourseMappingStatusSummaryData.pending_courses ? getCourseMappingStatusSummaryData.pending_courses : '0'}</td>
                                    </tr>
                                    <tr className="col-cnt-tab-bg-clr" style={{ height: '40px' }}>

                                      <th colSpan="2" style={{ textAlign: "center", verticalAlign: "middle", width: '50%', }}>Approved Courses</th>
                                      <td colSpan="2" style={{ textAlign: "center", verticalAlign: "middle", width: '50%', }}>{getCourseMappingStatusSummaryData.approved_courses ? getCourseMappingStatusSummaryData.approved_courses : '0'}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div></div>
                        </div>

                        <div className="pgm-map-box mb-4" style={{ zIndex: '1200' }}>
                          {/* <div className="txt-aln">
                            <h5>Discipline: {courseDiciplineNameData || ''}</h5>
                          </div> */}
                          <div className="txt-aln-end">
                            <button
                              className="lbl2 btn btn-primary mt-3 mb-3"
                              onClick={() => handleGeneratePDFNew(courseDiciplineIDData, courseDiciplineNameData)}
                              title="Download"
                            >
                              <i class="bi bi-arrow-down-square"></i>
                            </button>
                          </div>
                          <table class="display dataTable table-striped table-bordered ex-v-table">
                            <thead>
                              <tr className="bg-primary">
                                <th width="50%">Courses</th>
                                <th width="50%">Assigned Teacher(s)</th>
                              </tr>
                            </thead>
                            <tbody>

                              {getCourseData.map((course, index) => {

                                // Filter teachers who have this course_id
                                const relatedTeachers = getCollegeTeacherData.filter(teacher =>
                                  teacher.courses?.includes(course.course_id)

                                );

                                // If no teacher found, show "No Teacher Assigned"
                                if (relatedTeachers.length === 0) {
                                  return (
                                    <tr key={index}>
                                      <td>
                                        <div>
                                          <div>{course.avail_course}</div>
                                          <div className="text-center mt-2">
                                            {course.course_status === 'approved' && (
                                              <span className="badge bg-success ms-2">Approved Mapping</span>
                                            )}
                                            {course.course_status === 'mapped' && (
                                              <span className="badge bg-info text-dark ms-2">Mapped</span>
                                            )}

                                            {(course.course_status == null || course.course_status == undefined || course.course_status == '') && (
                                              <span className="badge bg-warning text-dark ms-2">Not Mapped</span>
                                            )}
                                          </div>
                                        </div>
                                      </td>
                                      <td><em>No teacher assigned</em></td>
                                    </tr>
                                  );
                                }

                                // If teachers found, render with rowspan
                                return relatedTeachers.map((teacher, tIndex) => (
                                  <tr key={`${index}-${tIndex}`}>
                                    {tIndex === 0 && (
                                      <td rowSpan={relatedTeachers.length}>
                                        <div>
                                          <div>{course.avail_course}</div>
                                          <div className="text-center mt-2">

                                            {course.course_status === 'approved' && (
                                              <span className="badge bg-success ms-2">Approved Mapping</span>
                                            )}
                                            {course.course_status === 'mapped' && (
                                              <span className="badge bg-info text-dark ms-2">Mapped</span>
                                            )}

                                            {(course.course_status == null || course.course_status == undefined || course.course_status == '') && (
                                              <span className="badge bg-warning text-dark ms-2">Not Mapped</span>
                                            )}


                                          </div>
                                        </div>
                                      </td>
                                    )}
                                    <td><strong>
                                      {teacher.full_name}
                                      <br />
                                      {teacher.email}<br />
                                      <small><b>{teacher.mobile_number}</b></small>
                                    </strong></td>
                                  </tr>
                                ));
                              })}
                            </tbody>
                          </table>
                        </div>
                        <div className="txt-aln">

                          {/* Old button code end here */}
                          {/* {!getCourseData.every(course => course.course_status?.trim().toLowerCase() === 'approved') && (
                            <button className="btn btn-primary me-3" type="submit" onClick={handlefirstsubmit}>
                              Approve
                            </button> 
                          )} 
                           */}
                          {/* Old button code end here */}


                          {/* New button code */}

                          {(getActiveEvents && getActiveEvents.status === 'active' &&
                            !getCourseData.every(course => course.course_status?.trim().toLowerCase() === 'approved')
                          ) && (
                              <button
                                className="btn btn-primary me-3"
                                type="submit"
                                onClick={handlefirstsubmit}
                              >
                                Approve
                              </button>
                            )
                          }
                          {/* New button code  end */}
                          {(getActiveEvents && getActiveEvents.status !== 'active' &&

                            <p style={{ color: 'red' }}>The approval time is closed.</p>

                          )}

                          {/* <input className="btn btn-light" type="reset" style={{ border: '2px solid black' }} value="Cancel" onClick={cancelForm} /> */}
                        </div>


                      </div>

                      <div className={`modal fade show ${isFirstSubmit ? 'd-block' : ''}`} id="exampleModalCenter1" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenter1" aria-model="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                          <div className="modal-content">
                            <div className="modal-body">
                              <div className="modal-toggle-wrapper">
                                {unmappedCount > 0 ? (
                                  <h4 className="text-center pb-2">
                                    {unmappedCount} course{unmappedCount > 1 ? 's' : ''} are not mapped.
                                  </h4>
                                ) : (
                                  null
                                  // <h4 className="text-center pb-2">Are you sure you want to approve?</h4>
                                )}
                                <p className="txt-aln-jst">I, the Principal of <strong>{collegename}</strong>, hereby certify that all faculty members handling courses
                                  in the semester <strong>{decodedSemID}</strong> of <strong>{courseDiciplineNameData}</strong> discipline/department have been duly mapped in the college portal as per the directions
                                  issued by the University. I further certify that the qualifications of the faculty members handling
                                  each course are in compliance with the UGC Regulations, Government of Kerala norms, and the directions
                                  of the University.</p>
                                <h4 className="text-center pb-2">Are you sure you want to approve?</h4>


                                <div className="d-flex justify-content-center mt-3">
                                  <div>
                                    <button className="btn btn-danger mx-2" onClick={handleFinalSubmit}>Approve</button>
                                    <button
                                      className="btn"
                                      style={{ backgroundColor: 'white', borderColor: 'red', color: 'black' }}
                                      data-bs-dismiss="modal"
                                      onClick={handleCancel}
                                    >
                                      Cancel
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>


                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </Template>
    </>
  );
}
